import { defineStore } from 'pinia';

import { TeamSubject } from '../dtos/property-team.dto.interface';

/**
 * Which unit or building the property access dialog is about. Every open counts, so a second click
 * that lands while the dialog is still closing opens it again rather than being lost.
 */
export const usePropertyAccessDialogStore = defineStore('propertyAccessDialog', {
  state: (): { subject: TeamSubject | null; opened: number } => ({ subject: null, opened: 0 }),
  actions: {
    open(id: string, kind: TeamSubject['kind'] = 'property') {
      this.subject = { kind, id };
      this.opened++;
    },
  },
});
